<template>
  <website-layout>
    <div id="home">
      <div id="wrapper">

        <home-header/>

        <main id="main">

          <home-slider/>

          <home-objectives/>

          <home-about-us/>

          <home-price-planning/>

          <home-what-we-do/>

          <home-contact/>

        </main>

        <home-footer/>

      </div>
    </div>
  </website-layout>
</template>

<script>
import HomeHeader from './HomeHeader'
import HomeFooter from './HomeFooter'
import HomeSlider from './HomeSlider'
import HomeObjectives from './HomeObjectives'
import HomeAboutUs from './HomeAboutUs'
import HomePricePlanning from './HomePricePlanning'
import HomeWhatWeDo from './HomeWhatWeDo'
import HomeContact from './HomeContact'
export default {
  name: 'Home',
  components: {
    HomeContact,
    HomeWhatWeDo,
    HomePricePlanning,
    HomeAboutUs,
    HomeObjectives,
    HomeSlider,
    HomeFooter,
    HomeHeader
  }
}
</script>
